import {DownloadItem, IpcMainInvokeEvent} from "electron";
import {EventHandler} from "../EventDispatcher";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";
import getDownloadManager from "../../DependencyInjection/downloadManager";
import DocumentDownload from "../../Entity/DocumentDownload";
import getGetMediaDownloadToken from "../../DependencyInjection/getMediaDownloadToken";
import {
    FinishProgressStrategy,
    ProgressStrategy,
    SlowProgressStrategy,
    StarProgressStrategy,
    UpdateProgressStrategy
} from "../../Progress/ProgressStrategy";
import {DownloadProgress, DownloadResult} from "../../../../types/downloadManager";

const eventDispatcher = getEventDispatcher();
let documentDownload: DocumentDownload | null = null;

function onProgressReport(progress: DownloadProgress, item: DownloadItem) {
    const strategies: ProgressStrategy[] = [
        new UpdateProgressStrategy(),
        new SlowProgressStrategy(),
        new StarProgressStrategy(),
        new FinishProgressStrategy()
    ];

    for (const strategy of strategies) {
        if (strategy.isValid(progress, item)) {
            strategy.onProgress(progress, item);
        }
    }
}

async function downloadCallback(error: Error | null, result: DownloadResult): Promise<void> {
    if (null === error) {
        await eventDispatcher.dispatch('FinishCurrentDownloadAction', documentDownload);
        return;
    }

    console.warn("Error: Download seems to have been interrupted for file: \n", result.filePath);
    console.warn("Additional info with 'error' object in onProgress callback:");
    console.warn('error', error);
    console.warn('url', result.url);
    console.warn('filePath', result.filePath);

    await eventDispatcher.dispatch('FinishCurrentDownloadWithErrorAction', documentDownload);
}

const DownloadListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    documentDownload = DocumentDownload.from(content);
    if (documentDownload.canPartiallyDownload()) {
        await eventDispatcher.dispatch('PartialDownload', documentDownload);
        return;
    }

    const token: string | null = await getGetMediaDownloadToken().get(documentDownload.getUuid(), documentDownload.getSessionToken());
    if (null === token) {
        await eventDispatcher.dispatch('FinishCurrentDownloadWithErrorAction', documentDownload);
        return;
    }

    documentDownload.setToken(token);

    getDownloadManager().download({
        url: documentDownload.getUrlWithToken(),
        overwrite: true,
        filename: documentDownload.getUuid(),
        onProgress: onProgressReport
    }, downloadCallback);
}

export default DownloadListener;